import { CanceledError } from 'axios';
import { ApiError, ApiTimeoutError } from '../errors';
import { parseAxiosErrorMessage } from './parseAxiosErrorMessage';
const parseAxiosError = (error) => {
    var _a, _b, _c, _d;
    // handle timeout from axios `timeout` config property
    // or from AbortController injected in callApi method
    if (error.code === 'ECONNABORTED' && ((_a = error.message) === null || _a === void 0 ? void 0 : _a.startsWith('timeout'))
        || error instanceof CanceledError && ((_c = (_b = error.config) === null || _b === void 0 ? void 0 : _b.signal) === null || _c === void 0 ? void 0 : _c.reason) instanceof ApiTimeoutError) {
        let errorMessage = 'Request timeout out';
        const timeoutMs = (_d = error.config) === null || _d === void 0 ? void 0 : _d.timeout;
        if (timeoutMs)
            errorMessage += ` after ${timeoutMs} ms`;
        return new ApiTimeoutError(errorMessage, {
            cause: error,
            statusCode: error.status,
        });
    }
    return new ApiError(parseAxiosErrorMessage(error), {
        cause: error,
        statusCode: error.status,
    });
};
export default parseAxiosError;
//# sourceMappingURL=parseAxiosError.js.map